import React from "react";

import StaticPageStyles from "./static_pages.module.css"
import InstagramWarning from "../components/InstagramWarning";
import {useTranslation} from "react-i18next";

export default function FiledStylesPreview_en() {
    return <div className={StaticPageStyles.staticPageContainerCentered}>
        <InstagramWarning/>
        <h1>What will your LeelaOnline be like today?</h1>
        <h3>Choose your game mood</h3>
        <h4>Maybe you want to let the player choose? Simply send the link to this page.</h4>
        <br/>

        <h7>* This page contains examples of publicly available game field styles.</h7>
        <h7>* Private styles of hosts and restricted access styles are not displayed here</h7>
        <br/>
        <div className={StaticPageStyles.FieldStyleContainer}>
            <h3>The Path</h3>
            <div className={StaticPageStyles.FieldStyleSubContainer}>
                <img width={"60%"} src="https://leelaonline-web-assets.s3.eu-north-1.amazonaws.com/gamefieldpathpreview.png" alt={"GameField preview"}/>
                <ul>
                    <li>Author’s field by <a href="https://www.instagram.com/ishlyahova/" target="_blank">Iryna Shlyahova</a></li>
                    <li>Favorite field of the graduates of the school <a href="https://leela.academy/" target="_blank">"Leela. The Path of the Host"</a></li>
                    <li>You can <a href="https://leela.academy/game/" target="_blank">buy</a> it printed on fabric in high quality</li>
                    <li>Vivid, bright colors combined with a dark background inspire action</li>
                </ul>
            </div>
            <br/>
        </div>
        <br/>
        <div className={StaticPageStyles.FieldStyleContainer}>
            <h3>Jade Buddha</h3>
            <div className={StaticPageStyles.FieldStyleSubContainer}>
                <img width={"60%"} src="https://leelaonline-web-assets.s3.eu-north-1.amazonaws.com/gamefieldbuddahrpeview.jpg" alt={"GameField preview"}/>
                <ul>
                    <li>Field provided by <a href="https://www.instagram.com/soul.summit.a.k" target="_blank">SoulSummit</a> and <a href="https://www.instagram.com/alesia.soul.sound/" target="_blank">Olesya</a></li>
                    <li>The central element of the field is the emerald Buddha, a symbol of awakening and spiritual awareness.</li>
                    <li>Its rich green color embodies harmony, growth, and connection with the heart chakra, inspiring players to discover their true selves.</li>
                    <li>This field becomes a portal to inner transformation, where each step leads to a deeper understanding of life and spiritual essence.</li>
                </ul>
            </div>
            <br/>
        </div>
        <br/>
        <div className={StaticPageStyles.FieldStyleContainer}>
            <h3>Journey of Self-Discovery</h3>
            <div className={StaticPageStyles.FieldStyleSubContainer}>
                <img width={"60%"} src="https://leelaonline-web-assets.s3.eu-north-1.amazonaws.com/gamefieldkolodchenkopreview.jpg" alt={"GameField preview"}/>
                <div style={{marginLeft:"10px"}}>
                    <span>«Leela: A Journey of Self-Knowledge» is made to help you:</span>
                    <ul>
                        <li>realize the real causes of internal or external conflicts</li>
                        <li>face your shadow and accept it</li>
                        <li>find answers to deep questions - about love, money, vocation, body or soul</li>
                        <li>transform old programs and feel new power</li>
                    </ul>
                    <span>I invite you to a journey that starts with a single question and leads to a deep meeting with your true self.</span>
                    <br/>
                    <br/>
                    <span>Field provided by <a href="https://www.instagram.com/kolodchenko.nataliia/" target="_blank">Nataliya Kolodchenko</a></span>
                </div>
            </div>
            <br/>
        </div>
        <br/>
        <div className={StaticPageStyles.FieldStyleContainer}>
            <h3>Gaia</h3>
            <div className={StaticPageStyles.FieldStyleSubContainer}>
                <img width={"60%"} src="https://leelaonline-web-assets.s3.eu-north-1.amazonaws.com/gamefieldgayapreview.jpg" alt={"GameField preview"}/>
                <ul>
                    <li>The Gaia field was created by <a href="https://www.instagram.com/leela.designart/" target="_blank">Leela.designart</a> on order from <a href="https://www.instagram.com/sukhanova.inspire/" target="_blank">Olena Sukhanova</a> and is available to all LeelaOnline hosts</li>
                    <li>The game field depicts the Goddess Gaia - the embodiment of nature, fertility, and life force.</li>
                    <li>Each cell of the field is not just a step in the game, but a symbol of our interaction with Nature and the Inner World, an inspiring journey <i><b>Pro</b></i>life towards harmony with oneself.</li>
                </ul>
            </div>
            <br/>
        </div>
        <br/>
        <div className={StaticPageStyles.FieldStyleContainer}>
            <h3>Soul journey</h3>
            <div className={StaticPageStyles.FieldStyleSubContainer}>
                <img width={"60%"} src="https://leelaonline-web-assets.s3.eu-north-1.amazonaws.com/gamefieldpidhainapreview.jpg" alt={"GameField preview"}/>
                <ul>
                    <li>Unique field created by Lilia Pidhayna - favourite filed of students of "The art of Leela" course</li>
                    <li>It's not just a game, it's the mirror that shows your inner self</li>
                    <li>The field leads you to the journey to your soul</li>
                    <li>Every time strting the game you will live the small life and travel through the darkness and the light to realise who you really are.</li>
                    <br/>
                    <li>You can <a href="https://www.instagram.com/lilia_pidhayna/" target="_blank">buy it</a> printed on the high quality fabric</li>
                </ul>
            </div>
            <br/>
        </div>
        <br/>
        <div className={StaticPageStyles.FieldStyleContainer}>
            <h3>Calm</h3>
            <div className={StaticPageStyles.FieldStyleSubContainer}>
                <img width={"60%"} src="https://leelaonline-web-assets.s3.eu-north-1.amazonaws.com/gamefieldcalmrpeview.png" alt={"GameField preview"}/>
                <ul>
                    <li>The own field of the LeelaOnline project</li>
                    <li>Neutral colors, light details, just what you need to focus on the conversation with the host</li>
                    <li>Authors: Taras Karpenko and Iryna Petrenko</li>
                </ul>
            </div>
            <br/>
        </div>
        <br/>
        <div className={StaticPageStyles.FieldStyleContainer}>
            <h3>Dreams</h3>
            <div className={StaticPageStyles.FieldStyleSubContainer}>
                <img width={"60%"} src="https://leelaonline-web-assets.s3.eu-north-1.amazonaws.com/gamefielddreamspreview.png" alt={"GameField preview"}/>
                <ul>
                    <li>The own field of the LeelaOnline project</li>
                    <li>For those who are not afraid to dream</li>
                    <li>Authors: Yulia Semak and Taras Karpenko</li>
                </ul>
            </div>
            <br/>
        </div>
        <br/>
        <div className={StaticPageStyles.FieldStyleContainer}>
            <h3>Battle</h3>
            <div className={StaticPageStyles.FieldStyleSubContainer}>
                <img width={"60%"} src="https://leelaonline-web-assets.s3.eu-north-1.amazonaws.com/gamefieldfightpreview.jpg" alt={"GameField preview"}/>
                <ul>
                    <li>The own field of the LeelaOnline project</li>
                    <li>For those who is in the middle of the battle of Good and Evil</li>
                    <li>Authors: Taras Karpenko and Iryna Petrenko</li>
                </ul>
            </div>
            <br/>
        </div>
        <br/>
        <div className={StaticPageStyles.FieldStyleContainer}>
            <h3>Space</h3>
            <div className={StaticPageStyles.FieldStyleSubContainer}>
                <img width={"60%"} src="https://leelaonline-web-assets.s3.eu-north-1.amazonaws.com/gamefieldcosmospreview.jpg" alt={"GameField preview"}/>
                <ul>
                    <li>The own field of the LeelaOnline project</li>
                    <li>Less details, more focus</li>
                    <li>Authors: Taras Karpenko and Iryna Petrenko</li>
                </ul>
            </div>
            <br/>
        </div>
        <br/>
        <div className={StaticPageStyles.FieldStyleContainer}>
            <h3>Mask</h3>
            <div className={StaticPageStyles.FieldStyleSubContainer}>
                <img width={"60%"} src="https://leelaonline-web-assets.s3.eu-north-1.amazonaws.com/gamefieldmaskpreview.png" alt={"GameField preview"}/>
                <ul>
                    <li>Author <a href="https://www.instagram.com/oskavronska/" target="_blank">Olha Skavronska</a></li>
                    <li>Designer <a href="https://www.instagram.com/leela.designart/" target="_blank">Leela.designart</a> </li>
                    <li>The truth is always within us, but to see it, we must remove the mask. And this can only be done through honesty — with ourselves, with life, with others.</li>
                    <li>This space is a moment of inner awakening. It invites you into the depths of yourself, where it is frightening, but truthful.</li>
                    <li>It is here that the noise of roles quiets down, and the soul begins to speak. The mask falls — only what is true remains.</li>
                </ul>
            </div>
            <br/>
        </div>
        <br/>
        <div className={StaticPageStyles.FieldStyleContainer}>
            <h3>Key</h3>
            <div className={StaticPageStyles.FieldStyleSubContainer}>
                <img width={"60%"} src="https://leelaonline-web-assets.s3.eu-north-1.amazonaws.com/gamefieldkeypreview.png" alt={"GameField preview"}/>
                <ul>
                    <li>Author <a href="https://www.instagram.com/oskavronska/" target="_blank">Olha Skavronska</a></li>
                    <li>Designer <a href="https://www.instagram.com/leela.designart/" target="_blank">Leela.designart</a> </li>
                    <li>The key is you yourself: your consciousness, your heart. Everything that seems like obstacles (snakes, arrows, smoke) are merely layers on the path to yourself. This is a moment of great courage — to touch your own essence.</li>
                    <li>The field invites: ask yourself more deeply. Find the answer that changes everything. This is where the true entrance inward begins — through courage, through truth, through yourself.</li>
                    <li>One who manages to take the key will never be the same again.</li>
                </ul>
            </div>
            <br/>
        </div>
        <br/>
        <div className={StaticPageStyles.FieldStyleContainer}>
            <h3>Inner universe</h3>
            <div className={StaticPageStyles.FieldStyleSubContainer}>
                <img width={"60%"} src="https://leelaonline-web-assets.s3.eu-north-1.amazonaws.com/gamefieldinneruniversepreview.png" alt={"GameField preview"}/>
                <ul>
                    <li>Author <a href="https://www.instagram.com/oskavronska/" target="_blank">Olha Skavronska</a></li>
                    <li>Designer <a href="https://www.instagram.com/leela.designart/" target="_blank">Leela.designart</a> </li>
                    <li>Deeply cosmic, inwardly star-like, meditative. Here, it feels not just like self-discovery — but a return to oneself.</li>
                    <li>This field invites the player to remember: Who am I? What is my mission? What am I here to bring into this life?</li>
                    <li>There is no more searching here — only remembering.</li>
                    <li>You are the Universe. And the whole journey was just the way back — to yourself.</li>
                </ul>
            </div>
            <br/>
        </div>
        <br/>
        <div className={StaticPageStyles.FieldStyleContainer}>
            <h3>Do you have your own field and want to use it in LeelaOnline?</h3>
            <ul>
                <li>Just for yourself?</li>
                <li>Or maybe for your friends?</li>
                <li>Or maybe you want to share it with the whole world and have it appear on this page?</li>
            </ul>
            <div>Write to us at <a href="mailto:support@leelaonline.net">support</a>, nothing is impossible</div>
            <br/>
        </div>

        <br/>

    </div>


}